"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadProgress = exports.DocumentsUpload = exports.documentsUploadTestIds = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const frontend_infra_snack_1 = require("@forto-dev/frontend-infra-snack");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const react_1 = require("react");
const react_dropzone_1 = tslib_1.__importDefault(require("react-dropzone"));
const getBaseContainerStyle = (theme) => ({
    width: '100%',
    height: '100px',
    borderWidth: theme.spacing(0.25),
    borderStyle: 'dashed',
    borderRadius: theme.spacing(0.75),
    background: theme.palette.background.default,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
});
const useStyles = (0, silhouette_core_1.makeStyles)((theme) => ({
    container: getBaseContainerStyle(theme),
    dropContainer: {
        ...getBaseContainerStyle(theme),
        cursor: 'pointer',
        padding: theme.spacing(1),
        userSelect: 'none',
    },
    progressContainer: {
        ...getBaseContainerStyle(theme),
        alignItems: 'stretch',
        height: 'auto',
        minHeight: '100px',
    },
}));
exports.documentsUploadTestIds = {
    dropzone: 'documents_upload-dropzone',
};
const DocumentsUpload = ({ onAllUploaded, handleError, allowedFormats, multi, upload, height, }) => {
    const [fileId, setFileId] = (0, react_1.useState)(0);
    const [fileTracks, setFileTracks] = (0, react_1.useState)([]);
    const snack = (0, frontend_infra_snack_1.useSnackService)();
    const hasMounted = (0, react_1.useRef)(false);
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const classes = useStyles();
    (0, react_1.useEffect)(() => {
        if (!hasMounted.current) {
            hasMounted.current = true;
            return;
        }
        if (hasMounted.current && fileTracks.length === 0) {
            onAllUploaded?.();
        }
    }, [fileTracks, onAllUploaded]);
    const isLoading = fileTracks.length > 0;
    const onHandleError = (e) => {
        const errMessage = e || 'Error occurred while uploading file';
        handleError(errMessage);
    };
    const onDrop = (acceptedFiles) => {
        if (multi !== true && acceptedFiles.length > 1) {
            const error = `Uploading of multiple files at the same time not supported for this Dropzone.`;
            onHandleError(error);
            return;
        }
        if (allowedFormats) {
            const fileTypes = allowedFormats.join(', ');
            acceptedFiles.forEach((file) => {
                const isFileSupported = allowedFormats.some((format) => file.name.toLowerCase().endsWith(format));
                if (!isFileSupported) {
                    const fileName = file.name;
                    const error = `Unsupported file format for file ${fileName}. Supported: ${fileTypes}`;
                    onHandleError(error);
                    snack.addSnack({
                        type: 'error',
                        message: translate('documents-upload-error_message', { fileName, fileTypes }),
                    });
                }
            });
        }
        Promise.all(acceptedFiles.map(uploadOneFile));
    };
    const uploadOneFile = async (file) => {
        const fileTrack = {
            id: fileId,
            name: file.name,
            progress: 0,
        };
        setFileId(fileId + 1);
        setFileTracks([...fileTracks, fileTrack]);
        return upload(file, (e) => onProgress(fileTrack, e))
            ?.then(() => onUploaded(fileTrack))
            .catch(onHandleError);
    };
    const onUploaded = (fileTrack) => {
        setFileTracks(fileTracks.filter((file) => file.id !== fileTrack.id));
    };
    const onProgress = (fileTrack, e) => {
        const progress = (e.loaded / e.total) * 100;
        setFileTracks(fileTracks.map((file) => (file.id === fileTrack.id ? { ...file, progress } : file)));
    };
    const heightStyle = height ? { height } : {};
    return ((0, jsx_runtime_1.jsx)("div", { children: isLoading ? ((0, jsx_runtime_1.jsx)("div", { className: classes.progressContainer, children: fileTracks.map((file) => ((0, jsx_runtime_1.jsx)(exports.UploadProgress, { fileName: file.name, progress: file.progress }, file.id))) })) : ((0, jsx_runtime_1.jsx)(react_dropzone_1.default, { onDrop: onDrop, children: ({ getRootProps, getInputProps }) => ((0, jsx_runtime_1.jsxs)("section", { ...getRootProps(), className: classes.dropContainer, style: heightStyle, children: [(0, jsx_runtime_1.jsx)("input", { "data-testid": exports.documentsUploadTestIds.dropzone, ...getInputProps(), "data-e2e-id": "select-upload_document-input", accept: allowedFormats?.join(',') }), translate('frontend-sdk_click_or_drag_upload')] })) })) }));
};
exports.DocumentsUpload = DocumentsUpload;
const useProgressStyles = (0, silhouette_core_1.makeStyles)((theme) => ({
    progressItem: {
        margin: theme.spacing(1, 2),
    },
}));
const UploadProgress = ({ fileName, progress }) => {
    const classes = useProgressStyles();
    return ((0, jsx_runtime_1.jsxs)("div", { className: classes.progressItem, children: [(0, jsx_runtime_1.jsx)("div", { children: fileName }), (0, jsx_runtime_1.jsx)(silhouette_core_1.LinearProgress, { variant: progress === 100 ? 'indeterminate' : 'determinate', value: progress })] }));
};
exports.UploadProgress = UploadProgress;
//# sourceMappingURL=DocumentsUpload.js.map